var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/global.js
// module id = 6
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 21 23 24 27 31 33 42 51 52 53 54 55 56 57 58 59 60 61 62 63 64 65 66 67 68 69 71 72 73 74 76 77 78 79 80 81 89 96 100 103 105 106 109 110 112 118 119 133 136 137 138 142 154 155 159 163 166 174 176 177 178 182 183 184 185 186 194 195 196 197 198 199 200 204 205 206 207 208 210 211 213 214 229 230 231 232 233 234 235 236 238 239 240 241 242 243 244 245 246 247 253 254 255 257 258 264 267 269 270 271 272 273 275 276 278 280 283 288 311